import React, { useState } from "react";
import { Card, CardContent, Button, TextField, Select, MenuItem } from "@mui/material";
import axios from "axios";
import "./ProductForm.css";

const ProductForm = () => {
    const [formData, setFormData] = useState({
        productName: "",
        description: "",
        extraDetails: "",
        price: "",
        category: "",
        offer: "",
        type: "",
        images: []
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleImageUpload = (e, index) => {
        const files = Array.from(e.target.files);
        let newImages = [...formData.images];

        if (files.length + newImages.length > 8) {
            alert("You can upload a maximum of 4 images.");
            return;
        }

        if (index !== undefined && newImages[index]) {
            newImages[index] = files[0];
        } else {
            newImages = [...newImages, ...files.slice(0, 4 - newImages.length)];
        }

        setFormData({ ...formData, images: newImages });
    };

    const handleDeleteImage = (index) => {
        const newImages = [...formData.images];
        if (newImages[index] instanceof File) {
            URL.revokeObjectURL(URL.createObjectURL(newImages[index]));
        }
        newImages.splice(index, 1);
        setFormData({ ...formData, images: newImages });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.images.length < 1) {
            alert("Please upload at least one image.");
            return;
        }

        // Upload images first
        const uploadPromises = formData.images.map(async (image) => {
            const formDataImage = new FormData();
            formDataImage.append("file", image);
            const response = await axios.post("http://localhost:5000/api/upload", formDataImage);
            return response.data.imageUrl;
        });

        const uploadedImageUrls = await Promise.all(uploadPromises);

        // Prepare final data
        const finalData = {
            ...formData,
            images: uploadedImageUrls,
            discountedPrice: formData.offer
                ? formData.price - (formData.price * formData.offer) / 100
                : formData.price,
        };

        await axios.post("http://localhost:5000/api/products", finalData);
        alert("Product added successfully!");
    };


    return (
        <Card className="product-form-container">
            <CardContent>
                <h2 className="form-title">Add Product</h2>
                <form onSubmit={handleSubmit} className="form-grid">
                    <TextField label="Product Name" name="productName" onChange={handleChange} required className="input-field" />
                    <TextField label="Description" name="description" multiline rows={3} onChange={handleChange} required className="textarea-field" />
                    <TextField label="Extra Details" name="extraDetails" multiline rows={2} onChange={handleChange} className="textarea-field" />
                    <TextField label="Price" type="number" name="price" onChange={handleChange} required className="input-field" />
                    <TextField label="Offer (%)" type="number" name="offer" onChange={handleChange} className="input-field" />
                    <div className="discounted-price">Discounted Price: {formData.offer ? formData.price - (formData.price * formData.offer) / 100 : formData.price}</div>
                    <Select name="category" onChange={handleChange} required className="select-field" displayEmpty>
                        <MenuItem value="">Select Category</MenuItem>
                        <MenuItem value="electronics">Electronics</MenuItem>
                        <MenuItem value="fashion">Fashion</MenuItem>
                        <MenuItem value="home">Home</MenuItem>
                    </Select>
                    <Select name="type" onChange={handleChange} required className="select-field" displayEmpty>
                        <MenuItem value="">Select Type</MenuItem>
                        <MenuItem value="new">New</MenuItem>
                        <MenuItem value="used">Used</MenuItem>
                    </Select>
                    <div className="image-preview-container">
                        {[...Array(4)].map((_, index) => (
                            <div key={index} className="image-preview-item">
                                {formData.images[index] ? (
                                    <div className="image-wrapper">
                                        <img src={URL.createObjectURL(formData.images[index])} alt="Preview" className="image-preview" />
                                        <div className="image-actions">
                                            <button type="button" className="delete-btn" onClick={() => handleDeleteImage(index)}>X</button>
                                            <input type="file" className="replace-input" accept="image/*" onChange={(e) => handleImageUpload(e, index)} />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="empty-image-slot" onClick={() => document.getElementById(`file-input-${index}`).click()}>
                                        +
                                        <input id={`file-input-${index}`} type="file" accept="image/*" onChange={(e) => handleImageUpload(e)} className="file-input" />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <Button type="submit" className="submit-button">Submit</Button>
                </form>
            </CardContent>
        </Card>
    );
};

export default ProductForm;